import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black py-16 border-t border-white/5 relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10"></div>
      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col items-center justify-center text-center">
          <div className="text-3xl font-bold tracking-[0.2em] mb-8 text-white uppercase">Vitæ Guitars</div>
          
          <div className="flex space-x-8 mb-12">
            <a href="https://www.instagram.com/VitaeGuitars" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-theme-primary-500 transition-all transform hover:scale-110 hover:-translate-y-1">
              <i className="fab fa-instagram text-2xl"></i>
            </a>
            <a href="https://www.facebook.com/VitaeGuitars" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-theme-primary-500 transition-all transform hover:scale-110 hover:-translate-y-1">
              <i className="fab fa-facebook text-2xl"></i>
            </a>
            <a href="https://www.youtube.com/@VitaeGuitars" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-theme-primary-500 transition-all transform hover:scale-110 hover:-translate-y-1">
              <i className="fab fa-youtube text-2xl"></i>
            </a>
            <a href="mailto:VitaeGuitars@gmail.com" className="text-gray-400 hover:text-theme-primary-500 transition-all transform hover:scale-110 hover:-translate-y-1">
              <i className="fas fa-envelope text-2xl"></i>
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-8 mb-12 text-sm tracking-widest uppercase text-gray-500">
            <a href="#models" className="hover:text-white transition-colors">Models</a>
            <a href="#about" className="hover:text-white transition-colors">About</a>
            <a href="#contact" className="hover:text-white transition-colors">Contact</a>
            <a href="https://vitaeguitars.threadless.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Merch</a>
            <a href="/terms" onClick={(e) => { e.preventDefault(); window.history.pushState({}, '', '/terms'); window.dispatchEvent(new PopStateEvent('popstate')); }} className="hover:text-white transition-colors">Terms & Warranty</a>
          </div>

          <div className="text-gray-600 text-xs tracking-widest uppercase">
            <p>&copy; {new Date().getFullYear()} Vitæ Guitars. Handcrafted by Dor Biton.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
